/**
 * JORotatingCity — animated city carousel slot for use inside the Hero title.
 * Auto-cycles through a list of cities (Istres, Miramas, Fos, Martigues...).
 */
import React, { useEffect, useState } from "react";

const DEFAULT_CITIES = ["Istres", "Miramas", "Fos-sur-Mer", "Martigues", "Salon", "Arles", "Aix"];

export default function JORotatingCity({ cities, intervalMs = 2200, className = "" }) {
  const list = (cities && cities.length > 0) ? cities : DEFAULT_CITIES;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), intervalMs);
    return () => clearInterval(t);
  }, [list.length, intervalMs]);

  return (
    <span
      className={`jo-rot-city ${className}`}
      style={{ display: "inline-block", position: "relative", verticalAlign: "baseline" }}
      data-testid="jo-rotating-city"
    >
      {/* Hidden longest-word ghost to reserve width — prevents layout jitter */}
      <span className="jo-rot-city-ghost" aria-hidden="true">
        {list.reduce((a, b) => (a.length >= b.length ? a : b))}
      </span>
      {list.map((c, i) => (
        <span
          key={c}
          className={`jo-rot-city-item ${i === idx ? "is-active" : ""}`}
          aria-hidden={i !== idx}
        >
          {c}
        </span>
      ))}
    </span>
  );
}
